//Dependencies
import Vue from 'vue';
import '../core/polyfills';

import Avatar from './components/global/Avatar';
import LoginForm from './components/login/LoginForm';
import ResetForm from './components/login/ResetForm';
import SignupForm from './components/login/SignupForm';
import LocaleSelector from './components/login/LocaleSelector';

window.event_bus = new Vue();

Vue.prototype.trans = window.trans;
Vue.prototype.transChoice = window.transChoice;

new Vue({
    el: '#app',
    components: {
        Avatar,
        LoginForm,
        ResetForm,
        SignupForm,
        LocaleSelector,
    },
    mounted() {
        window.event_bus.$on('csrf_mismatch', () => {
            window.location.reload(true);
        });
    },
});
